// react
import { useCallback } from 'react';
import { useParams } from 'react-router-dom';

// components
import { ChatView as ChatViewComponent } from '@karehero/llama';

// hooks
import { useChat } from 'hooks';
import { useSelector } from 'store';

// store
import { getAccount } from 'store/slices/iamSlice';

const ChatView = () => {
  // hooks
  const { id: chatID } = useParams();
  const { chat, sendMessage, isChatLoading } = useChat({ chatID });
  const account = useSelector(getAccount);

  // methods
  const handleSendMessage = useCallback(
    async (message: string) => {
      if (!chatID) return;
      await sendMessage(message);
    },
    [sendMessage, chatID],
  );

  return (
    <ChatViewComponent
      messages={chat?.messages}
      onSend={handleSendMessage}
      isTyping={isChatLoading}
      account={account}
    />
  );
};

export default ChatView;
